import { schemaCurrencyList } from "@ledgerhq/wallet-api-core";
export class CurrencyModule {
    client;
    constructor(client) {
        this.client = client;
    }
    /**
     * List cryptocurrencies supported by the connected wallet, providing filters by name or ticker
     *
     * @param params - Filters for currencies
     *
     * @returns The list of corresponding cryptocurrencies
     * @throws {@link RpcError} if an error occured on server side
     *
     * @beta Filtering not yet implemented
     */
    async list(params) {
        const listResult = await this.client.request("currency.list", {
            currencyIds: params?.currencyIds,
        });
        const safeResults = schemaCurrencyList.result.parse(listResult);
        return safeResults.currencies;
    }
}
//# sourceMappingURL=Currency.js.map